module.exports = __webpack_public_path__ + "static/media/upload.dc7c5001.svg";